import request from '@/utils/request'

export function getStealRatioList(data) {
  return request({
    url: 'api/v1/ratio/getList',
    method: 'get',
    params: data
  })
}

export function updateStealRatio(data) {
  return request({
    url: 'api/v1/ratio/updateList',
    method: 'post',
    data: data
  })
}

export function delStealRatio(data) {
  return request({
    url: 'api/v1/ratio/delete',
    method: 'delete',
    data: data
  })
}

export function exportStealRatio() {
  return request({
    url: 'api/v1/ratio/export',
    method: 'get'
  })
}

export function importStealRatio(data) {
  return request({
    url: 'api/v1/ratio/import',
    method: 'post',
    data: data
  })
}
